module.exports = __webpack_public_path__ + "media/bicycle.efbd9a43.ogg";